<template>
  <div class="about-company __box-wrap">
    <div class="__layout-wrap">
      <ul class="__layout-tab">
        <li
          v-for="(vo,idx) in tab"
          :key="vo"
          :class="{ 'on': idx == act }"
          @click="toggleTab(vo,idx)"
        >{{ vo }}
        </li>
      </ul>
      <div class="__layout-container">
        <div class="__layout-headline">{{ headline }}</div>
        <div class="__layout-content">


          <!-- 登录注册 -->
          <div
            v-show="act == 0"
            class="about">
            <p/>
            <p>1、注册时收不到手机验证码怎么办？
            </p>
            <p>收不到验证码可能有以下两种情况：
            </p>
            <p>1、手机可能装了拦截软件，短信已被拦截；
            </p>
            <p>2、手机信号不佳。
            </p>
            <p>如果以上方法还是无法帮您解决问题，请联系在线客服
            </p>
            <!--            <p>2、QQ无法授权登录潮国创意怎么办？
            </p>
            <p>针对QQ无法授权登录潮国创意的问题：
            </p>
            <p>请打开其他网站，尝试是否可以QQ登录
            </p>
            <p>注意：请确认您是退出其他网站之前的登录的状态，重新登录尝试QQ是否可以登录。
            </p>
            <p>情况1：可以登录其他网站，潮点无法登录，请您提供QQ号码、1P地址，提交客服核实。
            </p>
            <p>情况2：都不可以登录，这样情况有可能是您的公司网络限制或腾讯QQ服务出了问题，建议耐心等待网络修复或更换浏览器尝试。
            </p>
            <p>如果换浏览器还是无法解决，建议您使用其他方式注册潮国创意，如手机登录/注册。
            </p>
            <p>如果您的会员账号无法登录使用，联系在线客服处理。
            </p>
            <p>3、微信登录二维码怎么不跳转？
            </p>
            <p>可能存在的三种情况：
            </p>
            <p>当前网络不稳定-等待网络稳定刷新尝试使用。
            </p>
            <p>公司网络对微信使用有限制请联系公司网管协商解决。
            </p>
            <p>浏览器原因导致-切换其他浏览器，尝试是否可以正常使用。
            </p>
            <p>仍然无法解决，请联系人工客服！
            </p>-->
          </div>
          <!-- 版权声明 -->
          <div v-show="act == 1">

            <p>1、无法在线支付怎么办？可以公对公银行汇款吗？</p>
            可以公对公付款，请汇款至以下账户：</p>
            <p>户名：上海图魂网络科技有限公司</p>
            <p>帐号：03421100040015927</p>
            <p>开户行：中国农业银行股份有限公司上海浦三路支行</p>
            <p>汇款成功后，提供支付凭证、ID号码、联系方式，联系客服人员，客服确认到账后，即可为您开通会员。</p>
            <br>
            <p>2、购买会员可以开具发票吗？
            </p>
            <p>进入“个人中心-VIP会员”，点击“在线开票”申请，即可申请开具电子发票
            </p>
            <p>发票类型：增值税电子普通发票
            </p>
            <p>开票金额：实际支付金额
            </p>
            <p>开票内容：技术服务费
          </p></div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexExtend from "../common/protocol-extend";

export default {
  name: "LoginProtocol",
  mixins: [indexExtend],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    act: 0
  },
  data() {
    return {

      tab: [
        "登录注册",
        "支付相关",
      ]
    }
  },
  mounted() {
    this.headline = this.tab[this.act];
  }

}
</script>

<style lang="scss" scoped>
@import "pages/protocol/common/common";

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(150px);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}

</style>
